import { Map } from 'immutable';

/**
 * To convert an Immutable list to Immutable Map with key based on the value in the list.
 * @param list: List[A]
 * @param getKeyFunction: (A) => key : to get the key for the map, from each value in the list
 * @return ImmutableMap[key, A]
 */
export default function listToMap(list, getKeyFunction) {
  return list.reduce((acc, value) => acc.set(getKeyFunction(value), value), Map());
}